import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid2,
  MenuItem,
  Paper,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import Header from "../../components/Header";
import { Formik } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as yup from "yup";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useEffect, useMemo, useState } from "react";
import NotificationToaste from "../global/NotificationToaste";
import {
  AccessAlarm,
  Delete,
  PrecisionManufacturing,
  SaveAlt,
} from "@mui/icons-material";
import { tokens } from "../../theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
const top100Films = [
  { label: "PRDA-Anuradhapura", year: 1994 },
  { label: "Irrigation DPT", year: 1972 },
  { label: "ABC Consructions", year: 1974 },
];

const jobTypes = [
  { label: "Concrete Works", year: 1994 },
  { label: "Aluminium Works", year: 1972 },
  { label: "Brick Works", year: 1974 },
];

const Team = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [data, setData] = useState([]);
  useEffect(() => {
    loadAllRequests();
  }, []);

  const loadAllRequests = async () => {
    const result = await axios.get(`http://localhost:8080/api/v1/labreq`);
    setData(result.data);
  };

  const handleFormSubmit = async (values) => {
    console.log(values);

    await axios
      .post("http://localhost:8080/api/v1/labreq", values)
      .then(function (response) {
        console.log(response);
        setMessage("New request saved successfully..!");
        setMessageType("success");
        setOpen(true);
        loadAllRequests();
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };
  let navigate = useNavigate();

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorKey: "jobNo", //access nested data with dot notation
        header: "Job No",
        size: 10,
      },
      {
        accessorKey: "jobName",
        header: "Job Name",
        size: 200,
      },
      {
        accessorKey: "regDate", //normal accessorKey
        header: "Date",
        size: 80,
      },
      {
        accessorKey: "institute",
        header: "Institute",
        size: 100,
      },
      {
        accessorKey: "jobType",
        header: "Job Type",
        size: 100,
      },
    ],
    []
  );

  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    initialState: {
      density: "compact",
      pagination: { pageSize: 25, pageIndex: 0 },
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 50, 100, 150, 200],
      showFirstButton: true,
      showLastButton: true,
    },

    muiTableBodyRowProps: ({ row }) => ({
      //conditionally style expanded rows
      sx: {},
    }),

    // renderTopToolbarCustomActions: ({ table }) => (
    //   <Box sx={{ display: "flex", gap: "1rem", p: "4px" }}>
    //     <Button
    //       color="success"
    //       onClick={() => {
    //         navigate("/itemregistration");
    //       }}
    //       variant="contained"
    //     >
    //       Create New Item
    //       <AdfScannerRounded sx={{ marginLeft: "5px" }} />
    //     </Button>
    //     <Button color="warning" variant="contained">
    //       Open Modes
    //       <AdfScannerRounded sx={{ marginLeft: "5px" }} />
    //     </Button>
    //   </Box>
    // ),
    //customize built-in buttons in the top-right of top toolbar

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          console.info("View Profile", row);
          closeMenu();
        }}
      >
        <AccessAlarm /> &nbsp; View Profile
      </MenuItem>,
      <MenuItem
        key={2}
        onClick={() => {
          console.info("Remove", row);
          closeMenu();
        }}
      >
        <Delete /> &nbsp; Remove
      </MenuItem>,
      <MenuItem
        key={3}
        onClick={() => {
          console.info("Share", row);
          closeMenu();
        }}
      >
        <PrecisionManufacturing /> &nbsp; Share
      </MenuItem>,
    ],
  });

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "99%" }}
        elevation={3}
      >
        <Header title="New Job Request" subtitle="Create new requests" />

        <Formik
          onSubmit={handleFormSubmit}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="8px"
                gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 4",
                  },
                }}
              >
                <Grid2 spacing={0.5} container alignContent="center">
                  <Grid2 size={4}>
                    {" "}
                    <Typography
                      color={colors.redAccent[500]}
                      alignContent="center"
                      variant="h5"
                      sx={{
                        gridColumn: "span 1",
                        fontWeight: 800,
                        marginTop: "8px",
                      }}
                    >
                      Job No
                    </Typography>
                  </Grid2>
                  <Grid2 size={8}>
                    <Typography
                      alignContent="center"
                      color={colors.redAccent[500]}
                      variant="h5"
                      sx={{
                        gridColumn: "span 1",
                        marginTop: "8px",
                        fontWeight: 800,
                      }}
                    >
                      -- AUTO --
                    </Typography>
                  </Grid2>
                </Grid2>

                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Job Name"
                  size="small"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.jobName}
                  name="jobName"
                  error={!!touched.jobName && !!errors.jobName}
                  helperText={touched.jobName && errors.jobName}
                  sx={{ gridColumn: "span 2", marginTop: "8px" }}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer
                    sx={{
                      gridColumn: "span 1",
                      width: "100%",
                    }}
                    components={["DatePicker"]}
                  >
                    <DatePicker
                      label="Register Date"
                      sx={{ width: "100%" }}
                      onChange={(e) => {
                        values.regDate = e === null ? "" : e;
                        console.log(initialValues.regDate);
                      }}
                      slotProps={{
                        textField: {
                          variant: "outlined",
                          values: "",
                          size: "small",
                          error: touched.regDate && Boolean(errors.regDate),
                          helperText: touched.regDate && errors.regDate,
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
                <Autocomplete
                  options={top100Films}
                  freeSolo
                  sx={{ gridColumn: "span 2" }}
                  name="institute"
                  isOptionEqualToValue={(option) =>
                    (values.institute = option.label)
                  }
                  onChange={(e, v) =>
                    v !== null
                      ? (values.institute = v.label)
                      : (values.institute = "")
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      label="Institute / Contractor"
                      onChange={handleChange}
                      value={values.institute}
                      onBlur={handleBlur}
                      helperText={touched.institute && errors.institute}
                      error={!!touched.institute && !!errors.institute}
                    />
                  )}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  type="text"
                  label="Email"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 2" }}
                />
                <Autocomplete
                  options={jobTypes}
                  sx={{ gridColumn: "span 2" }}
                  name="jobType"
                  isOptionEqualToValue={(option) =>
                    (values.jobType = option.label)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Job Type"
                      size="small"
                      onChange={handleChange}
                      value={values.jobType}
                      onBlur={handleBlur}
                      helperText={touched.jobType && errors.jobType}
                      error={!!touched.jobType && !!errors.jobType}
                    />
                  )}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type="text"
                  label="Notes"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.note}
                  name="note"
                  size="small"
                  error={!!touched.note && !!errors.note}
                  helperText={touched.note && errors.note}
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>
              <Divider sx={{ marginTop: "5px" }} />
              <Box
                sx={{ marginTop: "10px" }}
                display="flex"
                justifyContent="flex-end"
                marginBottom="1px"
              >
                <Button
                  type="submit"
                  startIcon={<SaveAlt />}
                  color="secondary"
                  variant="contained"
                >
                  Save Request
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>

      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "99%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="All requests" subtitle="Update / Delete Requests" />

        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  regDate: yup.string().required("Register date is required"),
  jobName: yup.string().required("Job name is required"),
  institute: yup.string().required("Institute / Contractor is required"),
  email: yup.string().email("invalid email").required("Email is required"),
  // jobType: yup.string().required("Job type is required"),
  // note: yup.string().required("required"),
});

const initialValues = {
  regDate: "",
  jobName: "",
  jobNo: "",
  jobType: "",
  email: "",
  note: "",
  institute: "",
  status: false,
};

export default Team;
